import type { ProductKeys3P } from './3p-product-configs';

export type ProductKeyWithTimestampMap = Partial<Record<ProductKeys3P, string>>;

export const DEFAULT_BULK_CONNECT_STATE: {
    previous3pProducts: ProductKeyWithTimestampMap;
    bulkConnectBanner: {
        initialBannerDismissed: boolean;
        secondaryBannerDismissed: boolean;
    };
} = {
	previous3pProducts: {} as ProductKeyWithTimestampMap,
	bulkConnectBanner: {
		initialBannerDismissed: false,
		secondaryBannerDismissed: false,
	},
};

export type BulkConnectState = typeof DEFAULT_BULK_CONNECT_STATE;

export const NEWLY_CONNECTED_PRODUCTS_EXPIRY_MS: number = 24 * 60 * 60 * 1000;
